import { Suspense, useEffect, useState } from 'react'
import { Switch, Route, useHistory } from 'react-router-dom'
import Loading from './control/Loading'
import MainPageNotFound from './MainNotFound'
import MainPlayground from './MainPlayground'
import MainBackoffice from './MainBackoffice'
import MainMap from './MainMap'
import useRelogin from './hooks/useRelogin'
import { decryptAES } from './util/cipher'
import useAxiosInterceptor from './constant/useConfigAPI'
import DialogControl from './control/Dialog'

const Main = () => {
    const enablePlayground = process.env.REACT_APP_ENVIRONMENT?.toUpperCase() === 'DEV'
    const isLoading = false
    const { callServiceGetProfile } = useRelogin()
    const history = useHistory()
    // const [openDialogOk, setOpenDialogOk] = useState(false)

    const { openDialog, setOpenDialog, alertMessage, isExpiredSession, setIsExpiredSession } = useAxiosInterceptor()

    useEffect(() => {
        let localRefId = globalThis.sessionStorage.getItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)
        if (!localRefId) {
            localRefId = globalThis.localStorage.getItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)
        }

        if (localRefId) {
            const refId = localRefId ? JSON.parse(decryptAES(localRefId)) : null

            if (refId.accessToken) {
                globalThis.sessionStorage.setItem(`${process.env.REACT_APP_ACCESS_TOKEN_NBTC}`, refId.accessToken)
                callServiceGetProfile()
            } else {
                globalThis.sessionStorage.clear()
                globalThis.localStorage.removeItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)
                history.push('/')
            }
        }

        // const search = globalThis.location.search
        // const params = new URLSearchParams(search)
        // const error = params.get('error')
        // if (error && error === 'sessionexpired') {
        //     setOpenDialogOk(true)
        //     setAlertMessageOk('ระบบตรวจพบการเข้าใช้งานจากอุปกรณ์อื่น กรุณาเข้าสู่ระบบใหม่')
        // }
    }, [])

    const onClickOk = () => {
        setOpenDialog(false)

        if (isExpiredSession) {
            setIsExpiredSession(false)
            globalThis.sessionStorage.clear()
            globalThis.localStorage.removeItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)
            globalThis.location.href = `${process.env.PUBLIC_URL}`
        }
    }

    return (
        <Suspense fallback={<Loading size={150} />}>
            {isLoading ? (
                <Loading size={150} />
            ) : (
                <div style={{ width: '100%', height: '100%' }}>
                    <Loading size={150} />
                    <Switch>
                        {enablePlayground ? (
                            <Route path="/playground">
                                <MainPlayground />
                            </Route>
                        ) : null}
                        <Route path="/not-found">
                            <MainPageNotFound />
                        </Route>
                        <Route path="/backoffice">
                            <MainBackoffice />
                        </Route>
                        <Route path="/">
                            <MainMap />
                        </Route>
                    </Switch>
                </div>
            )}
            <DialogControl
                type="ok"
                title={'แจ้งเตือน'}
                content={alertMessage}
                isOpen={openDialog}
                onClickOk={onClickOk}
                labelButtonOk={'ตกลง'}
                disableClickBackdrop
                hideCloseButton
            />
        </Suspense>
    )
}

export default Main
